import { ServiceModeExperimentVariants } from 'experiments/service-mode/types';
import { RunningExperiments, useExperiments } from 'state/experiments';

export const useIsTopServiceModeEnabled = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.ServiceMode, ServiceModeExperimentVariants.SHOW_TSM);
};
